<template>
  <div class="dem-rel">
    <!-- SETA AS ABAS QUE DEVE MOSTRAR -->
    <!-- <div class="dem-rel-abas">
      Relatório: &nbsp;
      <div v-for="(aba, indexA) in abas" :key="'aba-' + indexA">
        <input :id='"dem-rel--" + aba.chave' type="radio" :value="aba.chave" class="app-checkbox" v-model="value" @input="appDemRelOnChange">
        <label :for='"dem-rel--" + aba.chave' v-html="aba.nome"></label>
      </div>
    </div> -->

    <!-- SETA O LOCAL PARA RECEBER O CONTEUDO DA TELA -->
    <!-- <router-view class="dem-rel-conteudo" v-if="time !== '' && value !== ''"></router-view> -->

    <RF-Aba v-if="Object.keys(abas).length >= 1"
    :cpntAbas="Object.values(abas)"
    :cpntValue="value"
    :cpntOnChange="appDemRelOnChange">
    <template slot='conteudo'>
      <router-view class="dem-rel-conteudo" v-if="time !== '' && value !== ''"></router-view>
    </template>
    </RF-Aba>
  </div>
</template>

<style scoped>
  .dem-rel > .dem-rel-abas > div {
    display: inline-block;
    margin-right: 15px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        requeire: true
      }
    },
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        abas: {},
        value: ''
      }
    },
    mounted: function () {
      this.appDemRelIniciar()
    },
    methods: {
      appDemRelIniciar: function () {
        // CHAMA A FUNÇÃO PAR MONTAR AS ABAS
        this.appDemRelMontarAbas()

        // SETA O VALOR DA ABA QUE ESTÁ ABERTA
        this.appDemRelSetarValorViaRota()

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appDemRelSetarValorViaRota: function () {
        // PEGA O NOME DA ROTA QUE ESTÁ ABERTA
        var route = this.$route.name

        // VERIFICA SE É A PAGINA INICIAL
        if (route === 'vendas_relatorio') {
          route = 'vendas_relatorio_contato'
        }

        // PEGA A ABA SOLICITADA
        var index = Object.keys(this.abas).filter(item => this.abas[item].router.indexOf(route) !== -1)

        // VERIFICA SE FOI ENCONTRADO ABA
        if (index.length >= 1) {
          // PEGA O NOME DA ABA
          var aba = index[0]

          // PEGA A ABA INFORMADA
          this.appDemRelOnChange(aba)
        }
      },
      appDemRelMontarAbas: function () {
        // INICIANDO A VARIAVEL
        var abas = {}

        // VERIFICA A DEMANDA QUE DEVE SER APRESENTADO
        switch (this.cpntDemanda) {
          case 'venda':
            // ADICIONA O BOTÃO RELATORIO POR CLIENTE
            abas.contato = { chave: 'contato', nome: 'Por Cliente', router: [ 'vendas_relatorio_contato' ] }
    
            // ADICIONA O BOTÃO RELATORIO POR PERIODO
            abas.periodo = { chave: 'periodo', nome: 'Por Período', router: [ 'vendas_relatorio_periodo' ] }
            
            // ADICIONA O BOTÃO ULTIMA VENDA
            abas.mais_usados = { chave: 'mais_usados', nome: 'Por Itens', router: [ 'vendas_relatorio_mais_usados', 'vendas_relatorio_mais_usados_busca' ] }
            
            // ADICIONA O BOTÃO ULTIMA VENDA
            abas.cat_mais_usadas = { chave: 'cat_mais_usadas', nome: 'Por Categorias', router: [ 'vendas_relatorio_cat_mais_usadas' ] }
            
            // ADICIONA O BOTÃO ULTIMA VENDA
            abas.ult_ven = { chave: 'ult_ven', nome: 'Última Venda', router: [ 'vendas_relatorio_ult_ven' ] }
            
            // ADICIONA O BOTÃO ULTIMA VENDA
            if ((this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, null, null, null, null, false) === true) || this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === false) {
              // && (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 4 ], 'and', null, null, null, null, false) === true || this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 23 ], 'and', null, null, null, null, false) === true || this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 20 ], 'and', null, null, null, null, false) === true)
              abas.pgto = { chave: 'pgto', nome: 'Consolidado por Forma de Pagamentos', router: [ 'vendas_relatorio_pgto' ] }
            }
            break

          case 'compra':
            // ADICIONA O BOTÃO RELATORIO POR FORNECEDOR
            abas.contato = { chave: 'contato', nome: 'Por Fornecedor', router: [ 'compras_relatorio_contato', 'compras_relatorio' ] }
    
            // ADICIONA O BOTÃO RELATORIO POR PERIODO
            abas.periodo = { chave: 'periodo', nome: 'Por Período', router: [ 'compras_relatorio_periodo' ] }

          // ADICIONA O BOTÃO ULTIMA COMPRA
            abas.mais_usados = { chave: 'mais_usados', nome: 'Por Itens', router: [ 'compras_relatorio_mais_usados', 'compras_relatorio_mais_usados_busca' ] }

            // ADICIONA O BOTÃO ULTIMA COMPRA
            abas.cat_mais_usadas = { chave: 'cat_mais_usadas', nome: 'Por Categorias', router: [ 'compras_relatorio_cat_mais_usadas' ] }
            break
        }

        // ADICIONA AS ABAS QUE PODEM SER ABERTAS
        this.abas = abas

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appDemRelOnChange: function (aba) {
        // SETA A ABA SELECIONADA
        this.value = aba
        
        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.abas[aba].carregado = false

        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.abas[aba].mostrar = false

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // PEGA O NOME DA ROTA
        var route = this.abas[aba].router.filter(item => item === this.$route.name)

        // VERIFICA SE FOI ENCONTRADO OU NÃO UMA ROTA
        if (route.length === 0) {
          route = this.abas[aba].router[0]
        }

        // SETA O NOME DA ROTA QUE DEVE ALTERAR
        this.$router.push({ name: route })
      }
    },
    watch: {
      'cpntDemanda': function () {
        // LIMPA VARIAVEL DE RESQUEST API VALIDAS
        this.$store.commit('SET_CANCEL_REQUEST_API')

        // SETA O FLAG PARA ATUALIZAR O COMPONENT
        this.$store.commit('SET_TIME_CONTEUDO', true)
      },
      '$route.name': function () {
        // LIMPA VARIAVEL DE RESQUEST API VALIDAS
        this.$store.commit('SET_CANCEL_REQUEST_API')

        // SETA O FLAG PARA ATUALIZAR O COMPONENT
        this.$store.commit('SET_TIME_CONTEUDO', true)
      }
    }
  }
</script>
